import { render } from "./BackToTop.vue?vue&type=template&id=580d4d65"
import script from "./BackToTop.vue?vue&type=script&lang=js"
export * from "./BackToTop.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./BackToTop.vue?vue&type=style&index=0&id=580d4d65&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script